import { Component } from '@angular/core';

@Component({
  templateUrl: './sidebar.component.html'
})
export class SettingsSidebarComponent {}



// WEBPACK FOOTER //
// /srv/src/app/settings/sidebar.component.ts